import React, { ReactElement } from "react";
import styles from "./divider.module.scss";

const Divider = (): ReactElement => {
  return <div className={styles.divider} />;
};

export default Divider;
